import { render, staticRenderFns } from "./fatLogin.vue?vue&type=template&id=caea917c&"
import script from "./fatLogin.vue?vue&type=script&lang=js&"
export * from "./fatLogin.vue?vue&type=script&lang=js&"
import style0 from "./fatLogin.vue?vue&type=style&index=0&id=caea917c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports